module.exports = __webpack_public_path__ + "img/0Q3A5746_L_Foamcore.6d3010a6.jpg";